import { render, staticRenderFns } from "./GlobalSidebarMenuItem.vue?vue&type=template&id=f082139c"
import script from "./GlobalSidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./GlobalSidebarMenuItem.vue?vue&type=script&lang=js"
import style0 from "./GlobalSidebarMenuItem.vue?vue&type=style&index=0&id=f082139c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports